import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { gen1Deprecated, OverlayManager } from '../../overlays';
import { bootstrapAction } from '../extensions';
import { currentFirmwareVersion, firstGenFirmwareVersion } from '../../config/receiver';

export class Gen1DeprecatedError extends Error {
  constructor() {
    super('Chromecast (Gen 1) is deprecated');
  }
}

export class ShutDownGen1Plugin implements PluginInterface {
  init(context: CastReceiverContext) {
    const overlayManager = new OverlayManager(
      document.getElementById('overlayContainer') as HTMLDivElement
    );
    bootstrapAction.register(async () => {
      if (currentFirmwareVersion === firstGenFirmwareVersion) {
        overlayManager.showOverlay(gen1Deprecated);
        setTimeout(() => context.stop(), 25000);
        throw new Gen1DeprecatedError();
      }
    });
  }
}
